import React from "react";
import {
  Form,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import SelectAdminLevel0 from "./SelectAdminLevel0";
import SelectLevel from "./SelectLevel";
import SelectAdminLevel1 from "./SelectAdminLevel1";
import SelectCountry from "./SelectCountry";

const RegionForm: React.FC<{
  toggle: () => void;
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  setLoading: (loading: boolean) => void;
}> = ({ validation, toggle, isUpdate, loading, setLoading }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <ModalBody>
        <input type="hidden" id="id-field" />

        <div className="mb-3">
          <Label htmlFor="id-field" className="form-label">
            Region/Location Name
          </Label>
          <Input
            name="name"
            id="name"
            className="form-control"
            placeholder="Enter region/location name"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.name || ""}
            invalid={
              validation.touched.name && validation.errors.name ? true : false
            }
          />
          {validation.touched.name && validation.errors.name ? (
            <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
          ) : null}
        </div>
        <Row>
          <Col md={6} className="mb-3">
            <SelectCountry validation={validation} />
          </Col>
          <Col md={6} className="mb-3">
            <SelectLevel validation={validation} />
          </Col>
        </Row>
        {validation.values.level?.value >= 1 ? (
          <div className="mb-3">
            <SelectAdminLevel0 validation={validation} />
          </div>
        ) : null}
        {validation.values.level?.value >= 2 ? (
          <div className="mb-3">
            <SelectAdminLevel1 validation={validation} />
          </div>
        ) : null}

        <Row>
          <Col md={6} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              X Coordinates
            </Label>
            <Input
              name="x_coord"
              id="x_coord"
              className="form-control"
              placeholder="Enter x coordinates"
              type="number"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.x_coord || ""}
              invalid={
                validation.touched.x_coord && validation.errors.x_coord
                  ? true
                  : false
              }
            />
            {validation.touched.x_coord && validation.errors.x_coord ? (
              <FormFeedback type="invalid">
                {validation.errors.x_coord}
              </FormFeedback>
            ) : null}
          </Col>
          <Col md={6} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Y Coordinates
            </Label>
            <Input
              name="y_coord"
              id="y_coord"
              className="form-control"
              placeholder="Enter y coordinates"
              type="number"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.y_coord || ""}
              invalid={
                validation.touched.y_coord && validation.errors.y_coord
                  ? true
                  : false
              }
            />
            {validation.touched.y_coord && validation.errors.y_coord ? (
              <FormFeedback type="invalid">
                {validation.errors.y_coord}
              </FormFeedback>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Alternative Name
            </Label>
            <Input
              name="altName1"
              id="altName1"
              className="form-control"
              placeholder="Enter alternative name"
              type="text"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.altName1 || ""}
              invalid={
                validation.touched.altName1 && validation.errors.altName1
                  ? true
                  : false
              }
            />
            {validation.touched.altName1 && validation.errors.altName1 ? (
              <FormFeedback type="invalid">
                {validation.errors.altName1}
              </FormFeedback>
            ) : null}
          </Col>
        </Row>
      </ModalBody>

      <div className="modal-footer">
        <div className="hstack gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading && (
              <Spinner
                color="light"
                size="sm"
                style={{ marginRight: "8px", marginBottom: "-1px" }}
              ></Spinner>
            )}
            {isUpdate ? "Update Region" : " Add Region"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default RegionForm;
